import useViewModel from "../viewModel";
import Creator from "./Creator";
import SuccessTip from "./SuccessTip";

/**
 * 参数
 *    pinId: number;
 *    suggestTags?: string[]; 推荐标签名列表
 *    boards?: Array; 画板列表
 *    onCloseCreator?: (pin, board) => void; 关闭回调。board=采集到的画板
 *    closeAfterDone?: boolean; 完成采集后自动关闭
 *    closeWaitSeconds?: number; 自动关闭前等待时间
 *
 * @param props {{
 *   pinId: number;
 *   targetAvatarUrl?: string;
 *   suggestTags?: string[];
 *   boards?: Board[];
 *   onCloseCreator?: (pin:Pin, board: Board) => void;
 *   closeAfterDone?: boolean;
 *   closeWaitSeconds?: number;
 *   showSuccessTip?: boolean;
 *   setCanBeSeen?: (visible: boolean) => void;
 * }}
 * @returns {JSX.Element}
 * @constructor
 */
export default function PinCreator(props) {
  const viewModel = useViewModel(props);
  const { newPin, showSuccessTip } = viewModel;
  return showSuccessTip && !!newPin ? (
    <SuccessTip viewModel={viewModel} />
  ) : (
    <Creator viewModel={viewModel} />
  );
}
